import Stack from '@mui/material/Stack';
import { Button } from '@openx/components-core/lib/Button/Button';
import { useTranslation } from 'react-i18next';
import { useAudienceInsights } from '../../context/audienceInsights';

export function PublisherActions() {
  const { t } = useTranslation();
  const { isGenerateButtonDisabled, isReportGenerated, generatePublisherReport } = useAudienceInsights();

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        justifyContent: 'flex-end',
      }}
    >
      {!isReportGenerated && (
        <Button color="primary" disabled={isGenerateButtonDisabled} onClick={generatePublisherReport}>
          {t('Generate Publisher Estimates')}
        </Button>
      )}
      <Button disabled={!isReportGenerated}>{t('Download')}</Button>
    </Stack>
  );
}
